import C from '../constants';

export const isAuthorized = (state = false, action) => {
    switch (action.type) {
        case C.CHANGE_AUTHORIZED:
            return action.statusLoad;
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// src/reducers/authorization.jsx